import { Box, Typography } from "@mui/material";
import {
  colorLandingBrand,
  colorLandingLine,
  colorLandingMuted,
  colorLandingSurface,
} from "src/design/tokens";

// One column per table; each booking is positioned by start time and duration.
const TABLES = [
  { id: "T1", booking: { label: "2 · 13h", top: "6%", height: "32%" } },
  { id: "T2", booking: { label: "2 · 21h", top: "56%", height: "30%" } },
  { id: "T3", booking: { label: "4 · 20h", top: "40%", height: "38%" } },
  { id: "T4", booking: null },
  { id: "T5", booking: { label: "6 · 19h", top: "16%", height: "44%" } },
  { id: "T6", booking: { label: "3 · 21h", top: "62%", height: "26%" } },
];

/** Table-schedule grid shown for the floor plan tab. */
export const FloorPlanMedia = () => (
  <Box sx={{ width: "100%" }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${TABLES.length}, 1fr)`,
        gap: 0.75,
        mb: 0.75,
      }}
    >
      {TABLES.map((table) => (
        <Typography
          key={table.id}
          sx={{
            textAlign: "center",
            fontSize: 9,
            fontWeight: 700,
            color: colorLandingMuted,
          }}
        >
          {table.id}
        </Typography>
      ))}
    </Box>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${TABLES.length}, 1fr)`,
        gap: 0.75,
        height: 132,
      }}
    >
      {TABLES.map((table) => (
        <Box
          key={table.id}
          sx={{
            backgroundColor: colorLandingSurface,
            border: `1px solid ${colorLandingLine}`,
            borderRadius: "6px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {table.booking && (
            <Box
              sx={{
                position: "absolute",
                left: 3,
                right: 3,
                top: table.booking.top,
                height: table.booking.height,
                backgroundColor: colorLandingBrand,
                borderRadius: "5px",
                color: colorLandingSurface,
                fontSize: 8,
                fontWeight: 700,
                px: 0.5,
                py: 0.375,
                lineHeight: 1.2,
              }}
            >
              {table.booking.label}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  </Box>
);
